import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { CLIENTES_COLUMNS, PROSPECTOS_COLUMNS, CUSTOMER_ACTIONS } from "@modules/private/customer/data/constants/customer.constants";
import { MessageService } from "primeng/api";
import { ApiCustomerService } from "@modules/private/customer/data/services/api/api-customer.service";
import { CustomerService } from "@modules/private/customer/data/services/view/customer.service";
import { ChannelSourcesViewService } from "@modules/private/omnichannel/data/services/view/channel-sources-view.service";
import { extractApiErrors } from "@data/utils/api-error.util";

@Component({
  selector: 'app-customer-list',
  templateUrl: './customer-list.component.html',
  styleUrls: ['./customer-list.component.scss'],
  providers: [MessageService]
})
export class CustomerListComponent implements OnInit {
  //* 2 pestañas por conversión (no por lease activo): Cliente = quien YA nos compró
  //* (`conversionStatus='won'`, sticky, no se degrada al liquidar) vs Prospecto (aún no
  //* gana: in_funnel / in_origination / lost). Un cliente que liquidó su único lease
  //* permanece en Clientes, marcado "Sin arrendamiento activo" (badge hasActiveLease).
  clientesColumns = CLIENTES_COLUMNS
  prospectosColumns = PROSPECTOS_COLUMNS
  clientesFilters = { conversionStatus: { value: 'won', matchMode: 'equals' } }
  prospectosFilters = { conversionStatus: { value: ['in_funnel', 'in_origination', 'lost'], matchMode: 'in' } }
  actions = CUSTOMER_ACTIONS
  createEntity = false
  editEntity = false
  selectedCustomerId: string | null = null
  action = 'CREATE'
  additionalMainActions = [
    { label: 'Nuevo cliente', icon: 'fa-solid fa-square-plus', action: 'CREATE', permission: ['clients', 'create'] as [string, string] }
  ]

  constructor(
    public apiCustomerService: ApiCustomerService,
    public customerService: CustomerService,
    private messageService: MessageService,
    private router: Router,
    private channelSources: ChannelSourcesViewService
  ) { }

  ngOnInit(): void {
    //* Carga el catálogo de canales para que el pipe `channelLabel` de la columna Canal
    //* (Prospectos) resuelva la key a su label amigable (digital → "Canal Digital", etc.).
    this.channelSources.loadAll(1, 100);
  }

  hideDialog() {
    this.createEntity = false;
    this.selectedCustomerId = null;
    this.action = 'CREATE';
  }

  mainActions(flow: string) {
    switch (flow) {
      case 'CREATE':
        this.customerService.newEntity()
        this.createEntity = true
        this.action = 'CREATE'
        break;
      case 'EDIT':
        // Este caso se manejará desde la tabla
        break;
      default:
        console.log(flow)
        break;
    }
  }

  // Nuevo método para edición
  editCustomer(customerId: string) {
    this.selectedCustomerId = customerId;
    this.action = 'EDIT';
    
    // Obtener datos del cliente
    this.apiCustomerService.getById(customerId).subscribe((response) => {
      if (!response.error) {
        // Cargar datos en el servicio
        this.customerService.loadEntityForEdit(response.data);
        this.createEntity = true;
      } else {
        this.messageService.add({ 
          severity: 'error', 
          summary: 'Error', 
          detail: response.msg 
        });
      }
    });
  }

  saveForm() {
    const data = this.customerService.entity.value;
    
    if (this.action === 'CREATE') {
      this.apiCustomerService.create(data).subscribe((r: any) => {
        if (r.error) return this.showApiErrors(r);

        this.messageService.add({ 
          severity: 'success', 
          summary: 'Éxito', 
          detail: `Cliente ${data.name} creado correctamente` 
        });
        this.hideDialog();
      });
    } else if (this.action === 'EDIT') {
      this.apiCustomerService.update(this.selectedCustomerId!, data).subscribe((r: any) => {
        if (r.error) return this.showApiErrors(r);

        this.messageService.add({ 
          severity: 'success', 
          summary: 'Éxito', 
          detail: `Cliente ${data.name} actualizado correctamente` 
        });
        this.hideDialog();
      });
    }
  }

  /**
   * Muestra los errores reales del backend (un toast por mensaje) en vez del
   * genérico "Bad Request". Los mensajes específicos en español viajan en
   * `r.data.errors` — ver `extractApiErrors`.
   */
  private showApiErrors(r: any) {
    const detalles = extractApiErrors(r, 'No se pudo guardar el cliente. Revisa los campos e inténtalo de nuevo.');
    this.messageService.addAll(
      detalles.map((detail) => ({ severity: 'error', summary: 'Revisa los campos', detail, life: 6000 }))
    );
  }

  handleTableAction(event: any) {
    const { action, data } = event;
    
    switch (action) {
      case 'EDIT':
        this.editCustomer(data._id);
        break;
    }
  }
}
